import posthog from 'posthog-js';

let initialised = false;

export function initTelemetry() {
  const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
  if (!key) return;
  posthog.init(key, {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    autocapture: true,
    session_recording: { maskAllInputs: true },
    opt_in_site_apps: true,
  });
  initialised = true;
}

export function identifyUser(
  userId: string,
  props: { abbreviation?: string | null; displayName: string }
) {
  if (!initialised) return;
  posthog.identify(userId, {
    displayName: props.displayName,
    abbreviation: props.abbreviation ?? null,
  });
}

export function resetUser() {
  if (!initialised) return;
  posthog.reset();
}

export function trackException(error: unknown) {
  const err = error instanceof Error ? error : new Error(String(error));
  if (!initialised) { console.error(err); return; }
  posthog.captureException(err);
}
